import apiClient from '../client';
import {
  BASE_ENDPOINTS,
  SERVICES,
  VERSIONS,
  RESOURCES
} from '../common/constants';

const CROP_BASE_V1 = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.CROP,
  false // No tenant ID in the base URL
);

export const getCropList = tenant =>
  apiClient.get(`${CROP_BASE_V1}/list?is_crop_calendar=true`);
